module.exports = __webpack_public_path__ + "img/products_icon.a704d4ec.svg";